import _ from 'lodash'
let type_name = {
  'pm25': 'PM₂.₅',
  'pm10': 'PM₁₀',
  'wind_speed': '风速',
  'wind_direction': '风向',
  'wendu': '温度',
  'shidu': '湿度',
  'particle_size_ratio': '粒径比例',
  'alarm_count': '报警次数',
  'gf_1': '国控点',
  'gf_2': '省控点',
  'gf_3': '市控点',
  'gf_4': '街镇控点',
  'point': '点图',
  'cloud': '云图',
  'jiezhen': '街镇色块',
  'quxian': '区县色块',
  'grid': '网格色块',
  'real': '秒',
  'min': '分',
  'hour': '时',
  'day': '日',
  'week': '周',
  'period': '旬',
  'month': '月',
  'year': '年'
}
let pm10SplitColor = []
let pm25SplitColor = []

let pm10RangeColor = []
let pm25RangeColor = []

// {start:0, end:1,value:'#67ce0b'}
let pm10RangeColor2 = []
let pm25RangeColor2 = []
// pmcolors.push(pm_invalid)

// let pm25_max = _.max(_.map(pmcolors,function(x){return x.lowval_pm25}))
// let pm10_max = _.max(_.map(pmcolors,function(x){return x.lowval_pm10}))
let pm25_max = 700
let pm10_max = 700

let color_max = {
  pm25: 700,
  pm10: 700
}
for (let i of pmcolors) {
  let sp1 = { start: i.lowval_pm25, end: i.highval_pm25 + 1, value: i.bgcolor }
  let sp2 = { start: i.lowval_pm10, end: i.highval_pm10 + 1, value: i.bgcolor }
  if (i.lowval_pm25 == 1) {
    sp1.start = 0
  }
  if (i.lowval_pm10 == 1) {
    sp2.start = 0
  }
  if (i.highval_pm25 == 350) {
    sp1.end = 100000
  }
  if (i.highval_pm10 == 500) {
    sp2.end = 100000
  }
  pm25SplitColor.push(sp1)
  pm10SplitColor.push(sp2)

  let pm25_r = ((i.lowval_pm25 + i.highval_pm25) / 2 / pm25_max)
  let pm10_r = ((i.lowval_pm10 + i.highval_pm10) / 2 / pm10_max)
  if (pm25_r > 1) {
    pm25_r = 1
  }
  if (pm10_r > 1) {
    pm10_r = 1
  }
  if (pm25_r < 0) {
    pm25_r = 0
  }
  if (pm10_r < 0) {
    pm10_r = 0
  }
  pm25RangeColor.push({ r: pm25_r, c: i.bgcolor })
  pm10RangeColor.push({ r: pm10_r, c: i.bgcolor })

  // pm25RangeColor2.push({r:pm25_r,c:i.bgcolor2})
  // pm10RangeColor2.push({r:pm10_r,c:i.bgcolor2})

}

for (let i of pmcolors) {
  let pm25_r = ((i.lowval_pm25 + i.highval_pm25) / 2 / 700)
  let pm10_r = ((i.lowval_pm10 + i.highval_pm10) / 2 / 700)
  if (pm25_r > 1) {
    pm25_r = 1
  }
  if (pm10_r > 1) {
    pm10_r = 1
  }
  if (pm25_r < 0) {
    pm25_r = 0
  }
  if (pm10_r < 0) {
    pm10_r = 0
  }

  pm25RangeColor2.push({ r: pm25_r, c: i.bgcolor2 })
  pm10RangeColor2.push({ r: pm10_r, c: i.bgcolor2 })
}

let split_color = {
  pm25: pm25SplitColor,
  pm10: pm10SplitColor,
  type: 'split'
}

let range_color1 = {
  pm25: pm25RangeColor,
  pm10: pm10RangeColor,
  type: 'color1'
}


let range_color2 = {
  pm25: pm25RangeColor2,
  pm10: pm10RangeColor2,
  type: 'color2'
}

let split_color_pm10_pm25 = [
  { start: 0, end: 1.5, value: 'green', label: '细颗粒' },
  { start: 1.5, end: 2.5, value: 'orange', label: '普通污染颗粒' },
  { start: 2.5, end: 100000, value: 'red', label: '扬尘' },
]

let font_color = {
  pm25: [{ start: 0, end: 115, color: 'black' }, { start: 116, end: 100000, color: 'white' }],
  pm10: [{ start: 0, end: 250, color: 'black' }, { start: 251, end: 100000, color: 'white' }]
}
console.log(range_color1)
let zoomCircleSize = {
  8: 2,
  9: 2,
  10: 3,
  11: 5,
  12: 7,
  13: 10,
  14: 15,
  15: 19,
  16: 19,
  17: 19,
  18: 19,
  19: 19
}

let timeSpace = {
  'min': 3600 * 4,
  'hour': 3600 * 24 * 3,
  'day': 3600 * 24 * 60,
  'week': 3600 * 24 * 7 * 18,
  'period': 3600 * 24 * 10 * 15,
  'month': 3600 * 24 * 31 * 4,
  'year': 3600 * 24 * 365 * 2
}

let time_range_std = {
  'min': [0, 2880],
  'hour': [2880, 14400],
  'day': [14401, 345600],
  'week': [345601, 2419200],
  'period': [],
  'month': [2419201, 9676800],
  'year': [9676801, 116121600],
}

let time_unit_info = {
  'min': 60,
  'hour': 3600,
  'day': 3600 * 24,
  'week': 3600 * 24 * 7,
  'period': 3600 * 24 * 10,
  'month': 3600 * 24 * 30,
  'year': 3600 * 24 * 365
}

let pollution_analysis_columns = [
  { id: 2, width: 80, label: "污染参数", prop: 'para' },
  { id: 3, width: 80, label: "浓度", prop: 'value' },
  { id: 4, width: 140, label: "开始时间", prop: 'time_start' },
  { id: 5, width: 140, label: "结束时间", prop: 'time_end' },
  { id: 6, width: 80, label: "风向", prop: 'wind_direction_name' },
]
let backInfo_columns = [
  { id: 1, type: 'index', width: 50, label: "序号" },
  { id: 2, width: 180, label: "微站名称", prop: 'param' },
  { id: 3, width: 100, label: "微站SN", prop: 'param' },
  { id: 4, width: 100, label: "贡献率", prop: 'param' },
  { id: 5, width: 180, label: "最高浓度", prop: 'param' },
  { id: 6, width: 100, label: "最高局部污染指数", prop: 'param' },
  { id: 7, width: 100, label: "向对方位", prop: 'param' },
  { id: 7, width: 100, label: "距离", prop: 'param' },
]
let paramsList = [
  { id: 1, label: "PM₂.₅", value: "pm25" },
  { id: 2, label: "PM₁₀", value: "pm10" },
  { id: 3, label: "NO₂", value: "no2" },
  { id: 4, label: "O₃", value: "o3" },
  { id: 5, label: "SO₂", value: "so2" },
  { id: 6, label: "CO", value: "co_f" },
]
export {
  range_color1,
  range_color2,
  split_color,
  type_name,
  zoomCircleSize,
  timeSpace,
  time_unit_info,
  time_range_std,
  font_color,
  color_max,
  split_color_pm10_pm25,
  pollution_analysis_columns,
  backInfo_columns,
  paramsList
}



// WEBPACK FOOTER //
// ./src/utils/common.js